/* eslint-disable jsdoc/require-returns */
/* eslint-disable jsdoc/require-param */
/* eslint-disable @typescript-eslint/no-inferrable-types */
/* eslint-disable valid-jsdoc */
/**
 * Defines the common functionalities of accumulation series
 */
import { isNullOrUndefined, Animation, createElement } from '@syncfusion/ej2-base';
import { degreeToLocation, getElement, indexFinder, linear } from '../../common/utils/helper';
import { pointByIndex } from '../model/acc-base';
/**
 * Accumulation Base used to do some base calculation for accumulation chart.
 */
export class AccumulationBase {
    /** @private */
    constructor(accumulation) {
        this.accumulation = accumulation;
    }
    /**
     * Gets the center of the pie
     *
     * @private
     */
    get center() {
        return this.pieCenter || (this.accumulation.visibleSeries[0].type === 'Pie' ?
            this.accumulation.pieSeriesModule.pieBaseCenter : null);
    }
    /**
     * Sets the center of the pie
     *
     * @private
     */
    set center(value) {
        this.pieCenter = value;
    }
    /**
     * Gets the radius of the pie
     *
     * @private
     */
    get radius() {
        return this.pieRadius !== undefined ? this.pieRadius :
            this.accumulation.pieSeriesModule.pieBaseRadius;
    }
    /**
     * Sets the radius of the pie
     *
     * @private
     */
    set radius(value) {
        this.pieRadius = value;
    }
    /**
     * Gets the label radius of the pie
     *
     * @private
     */
    get labelRadius() {
        return this.pieLabelRadius !== undefined ? this.pieLabelRadius :
            this.accumulation.pieSeriesModule.pieBaseLabelRadius;
    }
    /**
     * Sets the label radius of the pie
     *
     * @private
     */
    set labelRadius(value) {
        this.pieLabelRadius = value;
    }
    /**
     * Checks whether the series is circular or not
     *
     * @private
     */
    isCircular() {
        return this.accumulation.type === 'Pie';
    }
    /**
     * To check various radius pie
     *
     * @private
     */
    isVariousRadius() {
        return this.accumulation.pieSeriesModule.isRadiusMapped;
    }
    /**
     * To process the explode on accumulation chart loading
     *
     * @private
     */
    processExplode(event) {
        if (event.target.id.indexOf('_Series_') > -1 || event.target.id.indexOf('_datalabel_') > -1) {
            const pointIndex = indexFinder(event.target.id).point;
            if (isNaN(pointIndex) || (event.target.id.indexOf('_datalabel_') > -1 &&
                this.accumulation.visibleSeries[0].points[pointIndex].labelPosition === 'Outside')) {
                return null;
            }
            this.explodePoints(pointIndex, this.accumulation);
            this.deExplodeAll(pointIndex, this.accumulation.enableAnimation ? 300 : 0);
        }
    }
    /**
     * To invoke the explode on accumulation chart loading
     *
     * @private
     */
    invokeExplode() {
        const series = this.accumulation.visibleSeries[0];
        const duration = this.accumulation.enableAnimation ? 300 : 0;
        for (const point of series.points) {
            if (point.isExplode && point.y !== 0) {
                this.pointExplode(point.index, point, duration);
            }
        }
        if (this.accumulation.accumulationSelectionModule && this.accumulation.selectionMode !== 'None' &&
            this.accumulation.accumulationSelectionModule.selectedDataIndexes.length) {
            for (const index of this.accumulation.accumulationSelectionModule.selectedDataIndexes) {
                this.explodePoints(index.point, this.accumulation, true);
                this.deExplodeAll(index.point, duration);
            }
        }
    }
    /**
     * To deExplode all points in the series
     *
     * @private
     */
    deExplodeAll(index, animationDuration) {
        const pointId = this.accumulation.element.id + '_Series_0_Point_';
        const points = this.accumulation.visibleSeries[0].points;
        for (const currentPoint of points) {
            if ((index !== currentPoint.index && !currentPoint.isSliced) || currentPoint.isClubbed) {
                currentPoint.isExplode = false;
                this.deExplodeSlice(currentPoint.index, pointId, animationDuration);
            }
        }
    }
    /**
     * To explode point by index
     *
     * @private
     */
    explodePoints(index, chart, explode = false) {
        const series = chart.visibleSeries[0];
        const points = series.points;
        const point = pointByIndex(index, points);
        let explodePoints = true;
        const duration = this.accumulation.enableAnimation ? 300 : 0;
        if (isNullOrUndefined(point)) {
            return null;
        }
        const clubPointsExploded = !explode &&
            (point.isSliced || (series.clubbedPoints.length &&
                points[points.length - 1].index === series.clubbedPoints[series.clubbedPoints.length - 1].index));
        if (series.type === 'Pie' && (clubPointsExploded || point.isClubbed)) {
            explodePoints = this.clubPointExplode(index, point, series, points, chart, duration, clubPointsExploded);
        }
        if (explodePoints && point.y !== 0) {
            this.pointExplode(index, point, duration, explode);
        }
    }
    getSum(points) {
        let total = 0;
        points.map((point) => {
            total += point.visible ? point.y : 0;
        });
        return total;
    }
    clubPointExplode(index, point, series, points, chart, duration, clubPointsExploded = false) {
        if (point.isClubbed) {
            chart.animateSeries = false;
            points.splice(points.length - 1, 1);
            series.clubbedPoints.map((point) => {
                point.visible = true;
                point.isExplode = true;
            });
            chart.visibleSeries[0].points = points.concat(series.clubbedPoints);
            this.deExplodeAll(index, duration);
            series.sumOfPoints = this.getSum(chart.visibleSeries[0].points);
            chart.refreshChart();
            return false;
        }
        else if (clubPointsExploded || point.isSliced) {
            chart.animateSeries = false;
            points.splice(points.length - series.clubbedPoints.length, series.clubbedPoints.length);
            const clubPoint = series.generateClubPoint();
            clubPoint.index = points.length;
            clubPoint.color = series.clubbedPoints[0].color;
            points.push(clubPoint);
            series.sumOfPoints = this.getSum(points);
            this.deExplodeAll(index, duration);
            clubPoint.isExplode = false;
            chart.visibleSeries[0].points = points;
            chart.refreshChart();
            this.pointExplode(clubPoint.index, points[clubPoint.index], 0, true);
            clubPoint.isExplode = false;
            this.deExplodeSlice(clubPoint.index, chart.element.id + '_Series_0_Point_', duration);
            if (point.isSliced) {
                return false;
            }
        }
        return true;
    }
    /**
     * To Explode points
     *
     * @param {number} index Index of a point.
     * @param {AccPoints} point To get the point of explode.
     * @param {number} duration Duration of the explode point.
     * @param {boolean} explode Either true or false.
     */
    pointExplode(index, point, duration, explode) {
        let translate;
        const pointId = this.accumulation.element.id + '_Series_0_Point_';
        const chart = this.accumulation;
        if (!this.isCircular()) {
            translate = {
                x: ((point.labelRegion && point.labelRegion.x < point.region.x) ? -chart.explodeDistance :
                    chart.explodeDistance), y: 0
            };
        }
        else {
            translate = degreeToLocation(point.midAngle, chart.explodeDistance, this.center);
        }
        if (this.isExplode(pointId + index) || explode) {
            point.isExplode = true;
            this.explodeSlice(index, translate, pointId, this.center || { x: 0, y: 0 }, duration);
        }
        else {
            point.isExplode = false;
            this.deExplodeSlice(index, pointId, duration);
        }
    }
    /**
     * To check point is exploded by id
     */
    isExplode(id) {
        const element = getElement(id);
        const transform = element ? element.getAttribute('transform') : null;
        return (element && (transform === 'translate(0, 0)' || transform === null || transform === 'translate(0)'));
    }
    /**
     * To deExplode the point by index
     */
    deExplodeSlice(index, sliceId, animationDuration) {
        const element = getElement(sliceId + index);
        const transform = element ? element.getAttribute('transform') : null;
        if (this.accumulation.enableAnimation && element && transform &&
            transform !== 'translate(0, 0)' && transform !== 'translate(0)') {
            // eslint-disable-next-line security/detect-unsafe-regex
            const result = /translate\((-?\d+\.?\d*),?\s*(-?\d+[.]?\d*)?\)/.exec(transform);
            this.performAnimation(index, sliceId, 0, 0, +result[1], +result[2] || 0, animationDuration, true);
        }
        else {
            this.performAnimation(index, sliceId, 0, 0, 0, 0, animationDuration, true);
        }
    }
    /**
     * To translate the point elements by index and position
     */
    setTranslate(index, sliceId, position, transform) {
        this.setElementTransform(sliceId + index, position);
        if (this.accumulation.visibleSeries[0].dataLabel.visible) {
            sliceId = this.accumulation.element.id + '_datalabel_Series_0_';
            this.setElementTransform(sliceId + 'shape_' + index, position);
            this.setElementTransform(sliceId + 'text_' + index, position + transform);
            this.setElementTransform(sliceId + 'connector_' + index, position);
        }
    }
    /**
     * To translate the point element by id and position
     */
    setElementTransform(id, position) {
        const element = getElement(id);
        if (element) {
            element.setAttribute('transform', position);
        }
    }
    /**
     * To translate the point elements by index position
     */
    explodeSlice(index, translate, sliceId, center, animationDuration) {
        this.performAnimation(index, sliceId, 0, 0, translate.x - center.x, translate.y - center.y, animationDuration);
    }
    /**
     * To Perform animation point explode
     *
     * @param {number} index Index of the series.
     * @param {string} sliceId ID of the series.
     * @param {number} startX X value of start.
     * @param {number} startY Y value of start.
     * @param {number} endX X value of end.
     * @param {number} endY Y value of end.
     * @param {number} duration Duration of the animation.
     */
    performAnimation(index, sliceId, startX, startY, endX, endY, duration, isReverse) {
        const chart = this.accumulation;
        const values = sliceId.split('_');
        const seriesIndex = parseInt(sliceId.split('_')[values.length - 3], 10);
        const point = chart.visibleSeries[seriesIndex].points[index];
        if (duration <= 0) {
            this.setTranslate(index, sliceId, 'translate(' + (endX) + ', ' + (endY) + ')', point.transform);
            return null;
        }
        let xValue;
        let yValue;
        new Animation({}).animate(createElement('div'), {
            duration: duration,
            progress: (args) => {
                xValue = linear(args.timeStamp, startX, endX, args.duration);
                yValue = linear(args.timeStamp, startY, endY, args.duration);
                this.setTranslate(index, sliceId, 'translate(' + (isReverse ? endX - xValue : xValue) + ', ' + (isReverse ? endY - yValue : yValue) + ')', point.transform);
            },
            end: () => {
                this.setTranslate(index, sliceId, 'translate(' + (isReverse ? startX : endX) + ', ' + (isReverse ? startX : endY) + ')', point.transform);
            }
        });
    }
}
